import { call, put, takeLatest, all } from "redux-saga/effects";
import axiosInstance from "utils/axiosInstance";
import { FETCH_MISSING_IMAGES } from "store/imageMap/actionTypes";

// Redux States
import {
  FOLLOWERS_FETCH_REQUEST,
  FOLLOWERS_FETCH_SUCCESS,
  FOLLOWERS_FETCH_FAILURE,
} from "./actionTypes";


function* fetchFollowersSaga(action) {

  try {

    const [followerResponse] = yield all([
      call(axiosInstance.get, `/knovia/myInfo/followers`),
    ]);
    const followers = followerResponse.data;

    yield put({ type: FOLLOWERS_FETCH_SUCCESS, payload: followers });

    const filenames = followers
      .map(f => f.profileImage)
      .filter((filename) => filename);

    yield put({
      type: FETCH_MISSING_IMAGES,
      payload: { filenames }
    });

  } catch (err) {
    console.error('[fetchFollowersSaga] Error:', err);
    yield put({
      type: 'FOLLOWERS_FETCH_FAILURE',
      payload: err.message || 'Fetch failed'
    });
  }
}

function* followersSaga() {
  yield takeLatest(FOLLOWERS_FETCH_REQUEST, fetchFollowersSaga);
}

export default followersSaga;


